import { render, staticRenderFns } from "./AddCompareciente.vue?vue&type=template&id=0bc98318&scoped=true"
import script from "./AddCompareciente.vue?vue&type=script&lang=js"
export * from "./AddCompareciente.vue?vue&type=script&lang=js"
import style0 from "./AddCompareciente.vue?vue&type=style&index=0&id=0bc98318&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc98318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc98318')) {
      api.createRecord('0bc98318', component.options)
    } else {
      api.reload('0bc98318', component.options)
    }
    module.hot.accept("./AddCompareciente.vue?vue&type=template&id=0bc98318&scoped=true", function () {
      api.rerender('0bc98318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/AddCompareciente.vue"
export default component.exports